import type {
  FieldExtensionOptions,
  LayoutOptions,
} from '@backstage/plugin-scaffolder-react';
import { repoNameFromAppFieldOptions } from './RepoNameFromApp';
import { uniqueAppNameFieldOptions } from './UniqueAppName';
import { starterPickerFieldOptions } from './StarterPicker';
import { gitHubOAuthFieldOptions } from './GitHubOAuthField';
import { collapsibleSectionLayoutOptions } from './CollapsibleSection';

/**
 * Every custom field extension and layout this app provides, in one place.
 *
 * The stock `/create` route registers these as React children, and that is the
 * only registry there is: `useCustomFieldExtensions` reads a React outlet, so
 * there is no way to ask the app "what is registered?" from anywhere else.
 * Anything rendering a template outside that route — see DraftCreatePage —
 * renders `Workflow`, which takes `extensions`/`layouts` as props, so it has
 * to be handed this list explicitly.
 *
 * Keeping one exported list is what makes that safe, because passing an
 * incomplete one fails quietly: a `ui:field` with no matching extension falls
 * back to a plain widget with no warning. For GitHubOAuthField that means the
 * access probe never renders, no USER_OAUTH_TOKEN is collected, and the run
 * proceeds under the backend's own GitHub identity. A missing entry here is a
 * security problem, not a cosmetic one.
 *
 * Adding an extension: add it here, and render it inside
 * `<ScaffolderFieldExtensions>` in App.tsx. Both paths then have it.
 */
export const scaffolderFieldExtensions: FieldExtensionOptions<any, any>[] = [
  repoNameFromAppFieldOptions,
  uniqueAppNameFieldOptions,
  starterPickerFieldOptions,
  gitHubOAuthFieldOptions,
];

export const scaffolderLayouts: LayoutOptions[] = [
  collapsibleSectionLayoutOptions,
];
